/**
 * Textos de ayuda (tooltips) por concepto del dominio — fuente única.
 * Explican en lenguaje simple qué es cada cosa, para orientar al operador.
 * Se consumen con <HelpHint text={HELP_TEXT.xxx} />.
 */
export const HELP_TEXT = {
    platform:
        'El nivel más alto del sistema, operado por el equipo de Fiado. Desde aquí se crean y administran todas las organizaciones, aplicaciones y usuarios internos.',
    tenant: 'Cada empresa cliente que usa la plataforma. Sus datos, usuarios y configuración están aislados del resto (cada organización es un mundo aparte).',
    retailer:
        'Un comercio o cadena que opera dentro de una organización. Agrupa sus propias tiendas, usuarios y catálogo.',
    store: 'Un punto de venta concreto que pertenece a un comercio. Es el nivel más específico de la operación comercial.',
    group: 'Agrupación de agentes o equipos dentro de una organización. Organiza a las personas en una estructura jerárquica.',
    level: 'Los escalones internos de una organización. Según la aplicación, un nivel puede llamarse Región, Sucursal, etc. Cada uno cuelga del de arriba.',
    scope: 'El alcance de un rol: hasta dónde llega su poder. De mayor a menor: plataforma, organización y sus niveles (por ejemplo, región o sucursal). Un rol solo actúa dentro de su alcance.',
    scopeRef:
        'La entidad exacta a la que se aplica un rol dentro de su alcance. Por ejemplo, "esta región" o "esta tienda" en particular, no todas.',
    application:
        'Plantilla reutilizable que define los niveles, roles y permisos base de un tipo de negocio. Al crear una organización se le asigna una aplicación como molde.',
    tenantType:
        'Concepto anterior que definía la forma de una organización. Fue reemplazado por las Aplicaciones; hoy esta pantalla redirige a Aplicaciones.',
    user: 'Persona con acceso al sistema dentro de una organización. Recibe uno o más roles que determinan qué puede ver y hacer.',
    platformAdmin:
        'Miembros del equipo de Fiado que administran la plataforma completa: crean organizaciones, aplicaciones y otros usuarios internos.',
    tenantAdmin:
        'Dueño operativo de una organización. Gestiona usuarios, roles, seguridad, marca y auditoría dentro de su empresa.',
    role: 'Conjunto de permisos que se asigna a un usuario. Define qué acciones puede realizar sin tener que dar permisos uno por uno.',
    permission:
        'Autorización para una acción concreta (por ejemplo, crear usuarios o ver auditoría). Los roles se arman combinando permisos.',
    roleAssignment:
        'Acción de darle un rol a un usuario dentro de un alcance específico. Al asignarlo se elige a qué entidad (por ejemplo, región o tienda) aplica.',
    systemRole:
        'Rol predefinido que trae la plataforma y no se puede editar. Sirve como base estándar (por ejemplo, el administrador de la organización).',
    customRole:
        'Rol creado a la medida dentro de una organización, eligiendo qué permisos incluye. Solo puede usar permisos de su nivel, no de plataforma.',
    permissionCatalog:
        'Lista completa de permisos disponibles para armar roles. Cada permiso muestra su nombre y una descripción de lo que habilita.',
    branding:
        'La marca visual de cada organización: logo y colores. Personaliza la apariencia de la consola para esa organización.',
    customFields:
        'Campos extra que una organización define para sus usuarios, más allá de nombre y correo. Se pueden marcar como obligatorios.',
    externalId:
        'Cuando la organización aporta su propio identificador para una entidad (por ejemplo, grupo o tienda) en lugar de usar el que genera la plataforma.',
    requireExternalId:
        'Marca por nivel que obliga a la organización a traer su propio identificador para ese nivel. Si no se marca ninguno, la plataforma genera los identificadores.',
    securityPolicy:
        'Reglas de seguridad que aplican a todos los usuarios de una organización: métodos de verificación en dos pasos permitidos y lista de IPs autorizadas.',
    tenantStatus:
        'Situación actual de una organización: Activa (opera con normalidad) o Suspendida (bloqueada, sus usuarios no pueden entrar).',
    mfa: 'Verificación adicional al entrar, además de la contraseña. Puede ser una app autenticadora o un código por correo. Es obligatorio.',
    totp: 'Segundo factor con una app autenticadora que genera un código de 6 dígitos que cambia cada pocos segundos. Se configura escaneando un QR.',
    emailMfa:
        'Segundo factor mediante un código enviado a tu correo. Alternativa al autenticador cuando tu organización lo permite.',
    mfaReset:
        'Reinicia el segundo factor de un usuario. Cierra sus sesiones y lo obliga a configurarlo de nuevo al entrar.',
    passwordReset:
        'Reinicia la contraseña de un usuario, forzándolo a crear una nueva en su próximo ingreso.',
    activationLink:
        'Enlace que recibe un usuario nuevo por correo para activar su cuenta y crear su contraseña. Vence a los 7 días.',
    audit: 'Registro histórico de las acciones importantes hechas en el sistema. Permite revisar quién hizo qué y cuándo.',
    account:
        'Tu cuenta: tus datos de perfil y tu configuración de seguridad (contraseña y segundo factor).',
} as const;

export type HelpKey = keyof typeof HELP_TEXT;
